import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Util } from "@common/utils/util";
import { ACCOUNTS_BALANCE_FREEZING } from '@constants/business.constant';
import { ACCOUNTS } from '@constants/data-service.constant';
import { ROUTING_CONGELAMIENTOS_SALDOS } from "@constants/url.constant";
import { ModalService } from "@services/modal/modal.service";
import { StepsService } from '@services/steps/steps.service';
import { StorageService } from '@services/storage/storage.service';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { TEXT_CASES } from './congelamiento-saldos-cuentas.constants';


@Component({
    selector: "app-congelamiento-saldos-cuentas",
    templateUrl: "./congelamiento-saldos-cuentas.component.html",
    styleUrls: ["./congelamiento-saldos-cuentas.component.scss"],
    standalone: false
})
export class CongelamientoSaldosCuentasComponent implements OnInit {
  public loading: boolean = false;
  public error: boolean = false;
  public enableButtonRetry: boolean = false;
  public errorOps: GenericErrorOps;
  public ccoAmount: number = 0;
  public cdcAmount: number = 0;
  public ccvAmount: number = 0;
  public cavAmount: number = 0;
  public ccoSelectedAmount: number = 0;
  public cdcSelectedAmount: number = 0;
  public ccvSelectedAmount: number = 0;
  public cavSelectedAmount: number = 0;
  public ccoCheckbox: boolean = false;
  public cdcCheckbox: boolean = false;
  public ccvCheckbox: boolean = false;
  public cavCheckbox: boolean = false;
  public ccvCorrectlySelected: boolean = false;
  public cavCorrectlySelected: boolean = false;
  public titleLabel: string = "";
  public ccvSelectedPercentage: number = 0;  
  public cavSelectedPercentage: number = 0;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stepsService: StepsService,
    private readonly storageService: StorageService,
    private readonly utils: Util,
    private readonly modalService: ModalService
  ) {
    stepsService.setCurrentStep(1);
  }

  async ngOnInit() {
    const clientInfo = await this.storageService.get(ACCOUNTS);
    const accounts = clientInfo;
    this.setAccountAmounts(accounts);
    this.setTitleLabel();
  }

  private setAccountAmounts(accounts: any): void {
    for (let account of accounts) {
      switch (account.id) {
        case "CCO":
          this.ccoAmount = account.amount;
          break;
        case "CDC":
          this.cdcAmount = account.amount;
          break;
        case "CCV":
          this.ccvAmount = account.amount;
          break;
        case "CAV":
          this.cavAmount = account.amount;
          break;
      }
    }
  }

  private setTitleLabel(): void {
    if (this.isAnyObligatoryAccountWithFunds() && !this.isAnyVoluntaryAccountWithFunds()) {
      this.titleLabel = TEXT_CASES.obligatorias.label;
    } else if (!this.isAnyObligatoryAccountWithFunds() && this.isAnyVoluntaryAccountWithFunds()) {
      this.titleLabel = TEXT_CASES.voluntarias.label;
    } else if (this.isAnyObligatoryAccountWithFunds() && this.isAnyVoluntaryAccountWithFunds()) {
      this.titleLabel = TEXT_CASES.obligatorias_y_voluntarias.label;
    } else {
      throw new Error("No accounts with funds found.");
    }
  }

  public isAnyObligatoryAccountWithFunds(): boolean {
    return this.ccoAmount !== 0 || this.cdcAmount !== 0;
  }

  public isAnyVoluntaryAccountWithFunds(): boolean {
    return this.ccvAmount !== 0 || this.cavAmount !== 0;
  }

  public numberToChileanCurrency(value: number): string {
    return this.utils.formatCurrency(value);
  }

  public getSelectedObligatoryAccountsTotalAmount(): void {
    if (this.ccoCheckbox) {
      this.ccvSelectedAmount = this.ccoAmount;
    }
    if (this.cdcCheckbox) {
      this.cavSelectedAmount = this.cdcAmount;
    }
  }

  public getSelectedVoluntaryAccountsTotalAmount(): void {
    if (this.ccvCorrectlySelected) {
      this.ccvSelectedAmount = this.ccvAmount;
    }
    if (this.cavCorrectlySelected) {
      this.cavSelectedAmount = this.cavAmount;
    }
  }

  get isAnyAccountCorrectlySelected(): boolean {
    if (this.ccoCheckbox || this.cdcCheckbox) {
      return !this.isAnyVoluntaryAccountIncorrectlyChecked();
    } else if (this.ccvCorrectlySelected || this.cavCorrectlySelected) {
      return !this.isAnyVoluntaryAccountIncorrectlyChecked();
    } else {
      return false;
    }
  }

  isAnyVoluntaryAccountIncorrectlyChecked(): boolean {
    return this.ccvIsIncorrectlyChecked() || this.cavIsIncorrectlyChecked();
  }

  ccvIsIncorrectlyChecked(): boolean {
    return this.ccvCheckbox && !this.ccvCorrectlySelected;
  }

  cavIsIncorrectlyChecked(): boolean {
    return this.cavCheckbox && !this.cavCorrectlySelected;
  }

  get selectedTotalAmount(): number {
    return (
      this.ccoSelectedAmount +
      this.cdcSelectedAmount +
      this.ccvSelectedAmount +
      this.cavSelectedAmount
    );
  }

  async continue() {
    try {
      this.loading = true;
      this.setSelectedAmountsInStorage();
      await this.router.navigate(
        [`../${ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_CONFIRMAR}`],
        {
          relativeTo: this.activatedRoute,
        }
      );
    } catch (error) {
      console.error("Error al navegar:", error);
    } finally {
      this.loading = false;
    }
  }

  setSelectedAmountsInStorage(): void {
    this.storageService.set(ACCOUNTS_BALANCE_FREEZING, {
      ccoSelectedAmount: this.ccoSelectedAmount,
      cdcSelectedAmount: this.cdcSelectedAmount,
      ccvSelectedAmount: this.ccvSelectedAmount,
      cavSelectedAmount: this.cavSelectedAmount,
      ccvAmount: this.ccvAmount,
      cavAmount: this.cavAmount,
      selectedTotalAmount: this.selectedTotalAmount,
      cavSelectedAmountPercentage: this.cavSelectedPercentage,      
      ccvSelectedAmountPercentage: this.ccvSelectedPercentage,      
    })
  }

  async exit() {
    await this.modalService.congelamientoSaldosExitModal();
  }
}
